module.exports = __webpack_public_path__ + "img/contentImg2.c8ad8ec.webp";